import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import FallbackCard from '../../CommonComponents/FallbackCard';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';

const headCells = [
  {
    id: 'estimateId',
    numeric: true,
    label: 'EstimateId',
  },
  {
    id: 'estimateNo',
    numeric: false,
    label: 'EstimateNo',
  },
  {
    id: 'estimateDate',
    numeric: false,
    label: 'EstimateDate',
  },
  {
    id: 'companyName',
    numeric: false,
    label: 'CompanyName',
  },
  {
    id: 'regionName',
    numeric: false,
    label: 'RegionName',
  },
  {
    id: 'clientName',
    numeric: false,
    label: 'ClientName',
  },
  {
    id: 'productName',
    numeric: false,
    label: 'ProductName',
  },
  {
    id: 'campaignNo',
    numeric: false,
    label: 'CampaignNo',
  },
  {
    id: 'campaignDescription',
    numeric: false,
    label: 'CampaignDescription',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    width: 250,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
}));

const EstimatesTable = ({ estimates }) => {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('SiteId');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const finalRows = estimates.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

  return (
    <div className={classes.root}>
      {estimates.length > 0 ? (
        <div>
          <Paper className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {stableSort(finalRows, getComparator(order, orderBy))
                    .map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.estimateId}
                      >
                        <TableCell>{row.estimateId}</TableCell>
                        <TableCell>{row.estimateNo}</TableCell>
                        <TableCell>{moment(row.estimateDate).format('DD MMM YYYY, h:mm:ss a')}</TableCell>
                        <TableCell>{row.companyName}</TableCell>
                        <TableCell>{row.regionName}</TableCell>
                        <TableCell>{row.clientName}</TableCell>
                        <TableCell>{row.productName}</TableCell>
                        <TableCell>{row.campaignNo}</TableCell>
                        <TableCell>{row.campaignDescription}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 100]}
                      colSpan={3}
                      count={estimates.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}
    </div>
  );
};

const mapState = (state) => ({
  estimates: state.common.estimates,
});

export default connect(mapState, null)(EstimatesTable);
